
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import GooglePay from '../../js/google-pay/google-pay';
export default {
  data: function () {
    return {
      sheetPurches: null,
      buyAmount: 0,
      token: this.$root.getToken(),
      amount: 200,
      amounts: [
        {
          value: 100,
          active: false
        },
        {
          value: 180,
          active: true
        },
        {
          value: 900,
          active: false
        }
      ],
      visibleStar: this.$root.params.visibleStarIncreaseBalance
    };
  },
  methods: {
    SUBMIT() {
      this.$app.sheet.close('.success-purchase');
    },
    openSheetPopupSuccessPurchase() {
      try {
        this.$app.sheet.create({
          el: '.success-purchase',
          swipeToClose: true,
          backdrop: true
        }).open();
      } catch (e) {
      }
    },
    buyProduct(amount) {
      let self = this;
      let productName = null;
      self.$setState({ buyAmount: amount });
      if (window.webkit) {
        try {
          switch (amount) {
          case 100:
            productName = 'com.product.100';
            break;
          case 300:
            productName = 'com.product.300';
            break;
          case 500:
            productName = 'com.product.500';
            break;
          case 1000:
            productName = 'com.product.1000';
            break;
          }
          window.webkit.messageHandlers.iosListenerPurchases.postMessage(productName);
        } catch (e) {
          self.$app.dialog.alert('Временно недоступно, попробуйте позже', '');
        }
        return false;
      }
      if (window.store) {
        try {
          switch (amount) {
          case 15:
            productName = 'product.15';
            break;
          case 100:
            productName = 'product.100';
            break;
          case 300:
            productName = 'product.300';
            break;
          case 500:
            productName = 'product.500';
            break;
          case 1000:
            productName = 'product.1000';
            break;
          }
          store.order(productName);
        } catch (e) {
          self.$app.dialog.alert('Временно недоступно, попробуйте позже', '');
        }
        return false;
      }
      this.$app.dialog.alert('Недоступно для веба', '');
    },
    openAmountDialog() {
      var self = this;
      self.$router.navigate('/profile/input-in/');
    },
    amountIsExist(value) {
      var exist = false;
      for (var i = 0; i < this.amounts.length; i++) {
        if (this.amounts[i].value == value) {
          exist = true;
        }
      }
      return exist;
    },
    selectAmount(amount) {
      var self = this;
      var amounts = [];
      for (var i = 0; i < self.amounts.length; i++) {
        amounts.push({
          value: self.amounts[i].value,
          active: self.amounts[i].value === amount ? true : false
        });
      }
      self.$setState({
        amounts: amounts,
        amount: amount
      });
    },
    gotoPayment() {
      var self = this;
      var active = null;
      for (var i = 0; i < self.amounts.length; i++) {
        if (self.amounts[i].active) {
          active = self.amounts[i].value;
        }
      }
      if (!active) {
        return false;
      }
      self.$root.api('app/balance/coins/deposit', {
        'amount': active,
        'bonus': true
      }, 'POST', function (data, status, xhr) {
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message, 'Ошибка');
        } else {
          window.open(data.balance.uri, '_system');
          self.$router.navigate({ name: 'offer.step4' });
        }
      }, true, {});
    }
  },
  on: {
    pageInit: function () {
      var self = this;
      self.$el.find('.button--success').on('click', function () {
        self.$router.back();
      });
      try {
        delete self.$root.events.eventsListeners.openSuccessSheetPurchase;
        self.$root.events.on('openSuccessSheetPurchase', () => {
          try {
            const innerSelf = self;
            if (innerSelf.sheetPurches) {
              innerSelf.sheetPurches.open();
            } else {
              innerSelf.$setState({
                sheetPurches: innerSelf.$app.sheet.create({
                  el: '.success-purchase',
                  swipeToClose: true,
                  backdrop: true
                })
              });
              innerSelf.sheetPurches.open();
            }
          } catch (e) {
          }
        });
      } catch (e) {
      }
    },
    pageBeforeRemove: function () {
      this.$el.find('.button--success').off('click');
    }
  },
  id: '1da29085c6',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page">\n        <div class="navbar">\n            <div class="navbar-inner">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">\n                    Магазин кристалов\n                </div>\n            </div>\n        </div>\n\n        <div class="page-content">\n            <div class="block-title">Выберите продукт</div>\n\n            <div class="list products">\n                <ul>\n                    <!-- <li @click="buyProduct(\'15 кристалов\', 15)">\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">15 <i class="fas fa-star"></i></div>\n                                <div class="item-after">15 \u20BD</div>\n                            </div>\n                        </div>\n                    </li> -->\n                    <!-- <li @click="buyProduct(15)">\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">100 <i class="fas fa-star"></i></div>\n                                <div class="item-after">100 \u20BD</div>\n                            </div>\n                        </div>\n                    </li> -->\n                    <li @click="buyProduct(100)">\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">100 <i class="fas fa-star"></i></div>\n                                <div class="item-after">100 \u20BD</div>\n                            </div>\n                        </div>\n                    </li>\n                    <li @click="buyProduct(300)">\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">300 <i class="fas fa-star"></i></div>\n                                <div class="item-after">300 \u20BD</div>\n                            </div>\n                        </div>\n                    </li>\n                    <li @click="buyProduct(500)">\n                      <div class="item-content">\n                          <div class="item-inner">\n                              <div class="item-title">500 <i class="fas fa-star"></i></div>\n                              <div class="item-after">500 \u20BD</div>\n                          </div>\n                      </div>\n                   </li>\n                    <li @click="buyProduct(1000)">\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">1000 <i class="fas fa-star"></i></div>\n                                <div class="item-after">900 \u20BD</div>\n                            </div>\n                        </div>\n                    </li>\n                    <!-- ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.amounts, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li @click="selectAmount(';
          r += c(ctx_2.value, ctx_2);
          r += ')">\n                        <label class="item-radio item-content">\n                            <input type="radio" name="amount" value="';
          r += c(ctx_2.value, ctx_2);
          r += '" />\n                            <i class="icon icon-radio"></i>\n                            <div class="item-inner">\n                                <div class="item-title" style="display: inline-flex; align-items: center;">\n                                    ';
          r += c(ctx_2.value, ctx_2);
          r += ' <i class="fas fa-star fa-star--grey"></i>\n                                </div>\n                            </div>\n                        </label>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' -->\n\n                    <!-- <li class="no-chevron">\n                        <a href="#"  @click="openAmountDialog()" class="item-link item-content" style=" color:var(--f7-theme-color)">\n                            <div class="item-inner justify-content-center">Другая сумма</div>\n                        </a>\n                    </li> -->\n                </ul>\n            </div>\n\n            <div class="button_send">\n                <!-- <a class="link external button button-fill button-large button--success button button-fill button-large button--success"\n                    style="border-radius: 4px;"\n\n                    target="_blank"\n                    href="';
      r += c(ctx_1.$root.apiBaseUrl, ctx_1);
      r += 'app/balance/coins/deposit?amount=';
      r += c(ctx_1.amount, ctx_1);
      r += '&token=';
      r += c(ctx_1.token, ctx_1);
      r += '">\n                    Оплатить\n                </a> -->\n            </div>\n\n        </div>\n\n\n        <!-- Успешное всплывающее окно -->\n        <div class="sheet-modal success-purchase" style="height:auto; --f7-sheet-bg-color: #fff;">\n            <div class="sheet-modal-inner">\n              <div class="page-content">\n                <div class="block">\n                    <img src="./static/icons/success.png">\n                    <span class="title">Операция успешно выполнена</span>\n                    <span class="description">';
      r += c(ctx_1.buyAmount, ctx_1);
      r += ' <i class="fas fa-star"></i></span>\n                    <button class="button" @click="SUBMIT">Закрыть</button>\n                </div>\n              </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
[data-f7-1da29085c6] .pointer {
        cursor: pointer;
    }

[data-f7-1da29085c6] .list+.list {
        margin-top: 27px;
    }

[data-f7-1da29085c6] .item--success {
        color: #32BF61 !important;
    }

[data-f7-1da29085c6] .black {
        color: black !important;
    }

[data-f7-1da29085c6] .ml-mini {
        margin-left: 0.2em;
    }

[data-f7-1da29085c6] .button--success {
        height: 46px;
        background-color: #32BF61;
        font-size: 17px;
    }

[data-f7-1da29085c6] .list+.button_send {
        margin-top: 35px;
    }

[data-f7-1da29085c6] .button_send {
        padding: 0 8px;
    }

[data-f7-1da29085c6] .block-title {
        margin-top: 35px;
    }

[data-f7-1da29085c6] .preloader {
        width: 24px;
        height: 20px;
        position: absolute;
        top: 50%;
        margin-top: -11px;
        right: calc(var(--f7-safe-area-right) + 10px);
    }

[data-f7-1da29085c6] .item-inner--other_amount {
        justify-content: center;
    }

[data-f7-1da29085c6] .item-inner--other_amount>.item-title {
        color: #007AFF;
    }

[data-f7-1da29085c6] .page-content {
        background-color: unset;
    }
[data-f7-1da29085c6] .page-content .list.products li:active {
        background-color: var(--f7-list-link-pressed-bg-color);
    }
[data-f7-1da29085c6] .page-content .list.products .item-title {
        color: black;
        display: flex;
        align-items: center;
    }
[data-f7-1da29085c6] .page-content .list.products .item-title .fa-star {
        font-size: 15px;
        margin-left: 4px;
    }
`,
  styleScoped: true
};
    